import { useState, useEffect } from 'react'
import WaveSurfer from 'wavesurfer.js'
import Spectrogram from 'wavesurfer.js/dist/plugins/spectrogram.js'

// import WaveSurfer from 'https://unpkg.com/wavesurfer.js@beta'

export default function useWavesurfer(containerRef, options) {
  const [wavesurfer, setWavesurfer] = useState(null)

  useEffect(() => {
    // console.log('needSpectrogram => ', needSpectrogram)
    if (!containerRef.current) return

    if (!wavesurfer) {
      const ws = WaveSurfer.create({
        responsive: true,
        barWidth: 2,
        // barHeight: 1,
        // cursorWidth: 0,
        ...options,
        container: containerRef.current,
      })

      if (options.needSpectrogram) {
        ws.registerPlugin(
          Spectrogram.create({
            labels: true,
            height: 256,
          }),
        )
      }

      setWavesurfer(ws)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, containerRef])

  return wavesurfer
}
